module.exports = __webpack_public_path__ + "static/media/englishFlag.f5968ccf.svg";